import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getMembersAndCaseDocuments = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBERS_AND_CASE_DOCUMENTS_REQUEST });

  return api.eligibility.caseDoc.getMembersAndCaseDocuments(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBERS_AND_CASE_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBERS_AND_CASE_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};


export const getCaseByUserId = (userId: string, pageIndex: number, pageSize: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CASE_DOCUMENT_REQUEST });

  return api.eligibility.caseDoc.getCaseByUserId(userId, pageIndex, pageSize)
    .then((res: any) => {

      dispatch({
        type: types.GET_CASE_DOCUMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CASE_DOCUMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};


export const getCaseLetterInfo = (caseNo: number, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CASE_LETTER_INFO_REQUEST });

  return api.eligibility.caseDoc.getCaseLetterInfo(caseNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CASE_LETTER_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CASE_LETTER_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};


